import React from 'react';
import { commitments } from '../data/advantagePricing';
import { GuaranteeCard } from './GuaranteeCard';
export function AdvantageGuarantees() {
  return <div className="grid grid-cols-1 md:grid-cols-2 gap-8 items-stretch" data-id="element-30" data-mp="1ujdw9t9zlz87">
      <GuaranteeCard size="large" data-id="element-31" data-mp="28ina4maq0h90" />

      <div className="bg-slate-900/40 border border-slate-800 rounded-2xl p-10" data-id="element-32" data-mp="28epre1s21rpn">
        <div className="text-sm text-[#7FE0C3] uppercase tracking-widest mb-6" data-id="element-33" data-mp="23k3m8gckgve0">
          What We Need to Make That Guarantee
        </div>
        <ol className="space-y-6" data-id="element-34" data-mp="2dgosf50bocjf">
          {commitments.map((commitment, index) => <li key={commitment.title} className="flex items-start" data-id="element-35" data-mp="2r7bqcuy9dyeg" data-mpi={index}>
              <span className="w-8 h-8 rounded-full bg-[#7FE0C3]/10 border border-[#7FE0C3]/30 text-[#7FE0C3] text-sm font-bold flex items-center justify-center mr-4 mt-0.5 shrink-0" data-id="element-36" data-mp="2r9o56z8pzsna">
                {index + 1}
              </span>
              <div data-id="element-37" data-mp="2w6wnr0xs5yp2">
                <div className="text-white font-medium text-lg" data-id="element-38" data-mp="2w7pptolso00v">
                  {commitment.title}
                </div>
                <p className="text-slate-400 text-base leading-relaxed mt-1.5" data-id="element-39" data-mp="1dnuhoifiqit8">
                  {commitment.description}
                </p>
              </div>
            </li>)}
        </ol>
      </div>
    </div>;
}